<div class="qa-table-export">
  <div class="card mb-5">
    <div class="card-body">
      <div class="card-title">
        <div class="btn-toolbar justify-content-between">
          <div class="justify-content-between qa-lh-2p5">
            <i class="fa fa-table"></i>
            <h5 class="d-inline">{{_(KEYS.TABLE_EXPORT.TABLE_EXPORT)}}</h5>
          </div>
          <button class="btn btn-primary d-inline-block" (click)="isTableSearchCollapsed = !isTableSearchCollapsed">
            <i class="fa" [ngClass]="{'fa-arrow-down': isTableSearchCollapsed, 'fa-arrow-up': !isTableSearchCollapsed}"></i>
          </button>
        </div>
      </div>
      <div class="card-text" [ngbCollapse]="isTableSearchCollapsed">
        <div class="mt-2 mb-2 qa-grid-table-export">
          <div class="search-field field-span2">
            <label>{{_(KEYS.TABLE_EXPORT.QUESTIONNAIRE)}}</label>
            <app-select2
              [options]="selectOptions"
              [hideLabel]="true"
              [hideButton]="true"
              (selectedChange)="onQuestionnaireSelect($event)"
            >
              <option value="">...</option>
              <option *ngFor="let questionnaire of questionnaireTitles" value="{{questionnaire._id}}">
                {{questionnaire.title[locale]}}
              </option>
            </app-select2>
          </div>
          <div class="search-field">
            <label>{{_(KEYS.TABLE_EXPORT.OMIT_PATIENT_DATA)}}</label>
            <select class="form-control" [(ngModel)]="omitPatientData">
              <option value="0">{{_(KEYS.TABLE_EXPORT.NO)}}</option>
              <option value="1">{{_(KEYS.TABLE_EXPORT.YES)}}</option>
            </select>
          </div>
          <div class="search-field">
            <label>{{_(KEYS.TABLE_EXPORT.REV)}}</label>
            <select class="form-control" [(ngModel)]="selectedRevision">
              <option *ngFor="let revision of questionnaireRevisions" value="{{revision.revision}}">
                {{revision.revision}}
              </option>
              <option value="all" *ngIf="questionnaireRevisions && questionnaireRevisions.length">
                {{_(KEYS.TABLE_EXPORT.ALL_REVS)}}
              </option>
            </select>
          </div>
          <div class="search-field">
            <label>{{_(KEYS.TABLE_EXPORT.FROM)}}</label>
            <input
              type="text" class="form-control"
              ngbDatepicker #fromDate="ngbDatepicker"
              [(ngModel)]="selectedFromDate"
              (focus)="fromDate.toggle()"
            >
          </div>
          <div class="search-field">
            <label>{{_(KEYS.TABLE_EXPORT.TO)}}</label>
            <input
              type="text" class="form-control"
              ngbDatepicker #toDate="ngbDatepicker"
              [minDate]="toDateMin"
              [(ngModel)]="selectedToDate"
              (focus)="toDate.toggle()"
            >
          </div>
          <div class="search-field export-field">
            <label>{{_(KEYS.TABLE_EXPORT.EXPORT)}}</label>
            <button
              class="btn btn-success export-btn"
              (click)="onExport()"
              [attr.disabled]="(!canExport() || exportCount <= 0) ? true : null"
            >
              <i class="fa fa-download"></i>&nbsp;
              <ng-container *ngIf="exportCount > 0">{{exportCount}} {{_(KEYS.TABLE_EXPORT.RECORDS_EXPORT)}}</ng-container>
              <ng-container *ngIf="exportCount <= 0">{{_(KEYS.TABLE_EXPORT.NO_RECORDS)}}</ng-container>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

